import React from 'react';
import { RefundableInfo } from './RefundableInfo';
import { NonRefundableInfo } from './NonRefundableInfo';

const RefundabilityDisplay = ({
  index,
  check_in,
  cancelationFee,
  isaBuying = false,
  containerStyle = {},
  layout = 'stacked',
}) => {
  if (typeof cancelationFee?.CanBeCanceled !== 'boolean') return null;

  return cancelationFee.CanBeCanceled ? (
    <RefundableInfo
      index={index}
      check_in={check_in}
      cancelationFee={cancelationFee}
      isaBuying={isaBuying}
      containerStyle={containerStyle}
      layout={layout}
    />
  ) : (
    <NonRefundableInfo
      index={index}
      containerStyle={containerStyle}
      layout={layout}
    />
  );
};

export default RefundabilityDisplay;
